import React from 'react';
import RegistrationWizard from './RegistrationWizard';
import Dashboard from './Dashboard';

const App: React.FC = () => {
  const settings = (window as any).nifst_settings || {};
  const mode = settings.mode || 'wizard'; // 'wizard', 'dashboard', 'admin_edit'

  // If admin_edit, we reuse the Wizard but it handles is_admin internally
  if (mode === 'dashboard') {
    return <Dashboard />;
  }

  return <RegistrationWizard />;
};

export default App;
